import Table from "./Table";
import { TButton } from "./TButton";

export { TButton };

export default Table;
